import { useSearchParams, usePathname, useRouter } from 'next/navigation';

const useFilter = (filterKey: string) => {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const { replace } = useRouter();
  const handleFilterCurrency = (props?: string) => {
    const params = new URLSearchParams(searchParams);

    if (props) {
      params.set(filterKey, props);
    } else {
      params.delete(filterKey);
    }

    const query = params.toString();
    const newUrl = query ? `${pathname}?${query}` : pathname;

    replace(newUrl);
  };

  return { handleFilterCurrency };
};

export default useFilter;
